'use strict';
const angular = require('angular');
const {equals, extend, isFunction, isUndefined} = angular;

var template = require('./filter-input-directive.html');

module.exports = [
  FilterInputDirective];

//TODO: perhaps add a default settings that shows only sorting options?
function FilterInputDirective() {
  return {
    restrict: 'E',
    template: template,
    scope: {
      model: '=',
      filterModalOptions: '=?',
      collapse: '=?',
      onChange: '&',
      onFilterOptionsUpdate: '&',
      onSortOptionsUpdate: '&'
    },
    controllerAs: 'filterInput',
    bindToController: true,
    controller: ['$scope', '$attrs', '$timeout', '$modal', FilterInputController]
  }
}

function FilterInputController($scope, $attrs, $timeout, $modal) {
  var vm = this;
  vm.showFilterOptions = showFilterOptions;
  vm.openFilterOptions = openFilterOptions;
  vm.toggleCollapse = toggleCollapse;
  vm.searchOnly = isUndefined($attrs.searchOnly) || $attrs.searchOnly == 'true';
  vm.lockedOpenDesktop = $attrs.lockedOpenDesktop;
  vm.notDefaultOptions = false;

  var cancelWatch = $scope.$watch(function () {
    return vm.filterModalOptions !== null;
  }, function () {
    if (vm.filterModalOptions) {
      cancelWatch();
      updateDefaultOptions();
    }
  });

  if (vm.searchOnly) {
    vm.collapse = true;
  }

  function toggleCollapse() {
    vm.collapse = !vm.collapse;
  }

  function showFilterOptions() {
    return vm.model && $attrs.showFilterOptions == "true" && vm.collapse;
  }

  function openFilterOptions() {
    if (!vm.model) return;
    vm.model.filterOptions = vm.model.filterOptions || {};
    vm.model.sortOptions = vm.model.sortOptions || {};

    if (!vm.filterModalOptions.controller) {
      vm.filterModalOptions.controller = 'FilterDialogController';
    }

    if (!vm.filterModalOptions.animation) {
      vm.filterModalOptions.animation = 'slide-in-right';
    }

    $modal.show(vm.filterModalOptions).then(function (result) {
      extend(vm.model.filterOptions, result.filterOptions);
      extend(vm.model.sortOptions, result.sortOptions);

      var fn1 = vm.onFilterOptionsUpdate();
      if (isFunction(fn1)) {
        fn1(result.filterOptions);
      }

      var fn2 = vm.onSortOptionsUpdate();
      if (isFunction(fn2)) {
        fn2(result.sortOptions);
      }

      updateDefaultOptions();
    });
  }

  function updateDefaultOptions() {
    var originalValue = vm.notDefaultOptions;
    vm.notDefaultOptions = !vm.filterModalOptions.isDefaultFilterOptions(vm.model.filterOptions)
      || !equals(vm.filterModalOptions.locals.defaultSortOptions, vm.model.sortOptions);

    if (originalValue !== vm.notDefaultOptions && !vm.notDefaultOptions) {
      animateNotDefault();
    }
  }

  var isAnimating = false;

  function animateNotDefault() {
    if (isAnimating) return;
    isAnimating = vm.defaultOptionsPulse = true;

    $timeout(function () {
      isAnimating = vm.defaultOptionsPulse = false;
    }, 1000);
  }
}


// WEBPACK FOOTER //
// ./src/js/core-utilities/filters/FilterInputDirective.js